import { fetchAuthenticatedJson } from './authenticatedFetch';

const BASE = '/api/admin/telegram-publication-rules';

function request(url, options = {}) {
  return fetchAuthenticatedJson(url, {
    headers: { 'Content-Type': 'application/json' },
    ...options,
  });
}

export function fetchTelegramPublicationRules() {
  return request(BASE);
}

export function fetchTelegramPublicationRulesMetadata() {
  return request(`${BASE}/metadata`);
}

export function createTelegramPublicationRule(rule) {
  return request(BASE, { method: 'POST', body: JSON.stringify(rule) });
}

export function updateTelegramPublicationRule(id, rule) {
  return request(`${BASE}/${id}`, { method: 'PUT', body: JSON.stringify(rule) });
}

export function deleteTelegramPublicationRule(id) {
  return fetchAuthenticatedJson(`${BASE}/${id}`, { method: 'DELETE' });
}
